import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import AboutUsPage from '@/views/AboutUsPage.vue'
import ServicesPage from '@/views/ServicesPage.vue'
import ArticlesPage from '@/views/Articles.vue'
import SuccessStoriesPage from '@/views/SuccessStoriesPage.vue'
import ContactPage from '@/views/ContactPage.vue'
import PodcastPage from '@/views/PodcastPage.vue'
import BookPage from '@/views/BookPage.vue'
import ReferencesPage from '@/views/ReferencesPage.vue'
import ArticleDetailPage from '@/views/ArticleDetailPage.vue'
import EventsPage from '@/views/EventsPage.vue'
import AdminPage from '@/views/AdminPage.vue'
import LoginPage from '@/views/LoginPage.vue'

const routes = [
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/events',
    name: 'Events',
    component: EventsPage
  },
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUsPage
  },
  {
    path: '/what-we-do',
    name: 'Services',
    component: ServicesPage
  },
  {
    path: '/articles',
    name: 'Articles',
    component: ArticlesPage
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: ArticleDetailPage
  },
  {
    path: '/success-stories',
    name: 'SuccessStories',
    component: SuccessStoriesPage
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/podcast',
    name: 'Podcast',
    component: PodcastPage
  },
  {
    path: '/book',
    name: 'Book',
    component: BookPage
  },
  {
    path: '/references',
    name: 'References',
    component: ReferencesPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  if (to.path === '/admin') {
    // If navigating to the admin area, check if the user is logged in
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn === 'true') {
      next(); // Logged in, allow access
    } else {
      next('/login'); // Not logged in, redirect to login page
    }
  } else {
    next(); // Other pages are allowed
  }
});
export default router